import React, { useState, useEffect } from "react";
import { APP_SETTINGS } from "../../env";
import { servicesClient } from "../../index";
import { axiosInstance } from "../../fetcher";
import UpdateUser from "./UpdateUser";
import axios from "axios";
// import { APP_SETTINGS } from "../../env";

const UserAdministration = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("1122334455");
  const [role, setRole] = useState("user");
  const [users, setUsers] = useState([]);
  const [passwordError, setPasswordError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [engagementName, setEngagementName] = useState("");

  useEffect(() => {
    fetchUsers();
    fetchEngagementName();
    const adminStatus = sessionStorage.getItem("isAdmin") === "true";
    if (!adminStatus) {
      console.warn("User is not an admin");
      // Optionally redirect or show a message
    }
  }, []);

  const currentDomain = window.location.hostname.split(".")[1];

  let endpointToUse;

  if (currentDomain === "azurewebsites") {
    endpointToUse = new URL(APP_SETTINGS.public_endpoint).origin;
  } else {
    endpointToUse = new URL(APP_SETTINGS.private_endpoint).origin;
  }
  const fetchEngagementName = async () => {
    try {
      const currentUrl = endpointToUse; // Use the private endpoint from APP_SETTINGS
      // const currentUrl = window.location.origin; // Original code, but using APP_SETTINGS now
      // console.log("Current URL for fetching engagement name:", currentUrl);
      const response = await axiosInstance.post(
        "/engagements/get_engagements_name",
        { url: currentUrl }
      );
      setEngagementName(response.data.engagement_name);
    } catch (error) {
      console.error("Error fetching engagement name:", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const currentUrl = endpointToUse; // Use the private endpoint from APP_SETTINGS
      // const currentUrl = window.location.origin; // Original code, but using APP_SETTINGS now
      // console.log("Current URL for fetching users:", currentUrl);
      const response_eng = await axiosInstance.post(
        "/engagements/get_engagements_name",
        { url: currentUrl }
      );
      setEngagementName(response_eng.data.engagement_name);
      const response = await axiosInstance.post("/auth/admin/users", { engagements_name: response_eng.data.engagement_name });
      setUsers(response.data.users);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleResetPassword = async (userId) => {
    const newPassword = prompt("Enter new password:");
    if (!newPassword) {
      alert("Password reset cancelled.");
      return;
    }
    const passwordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
    if (!passwordRegex.test(password)) {
      alert(
        "Password must be at least 8 characters long, contain letters, numbers, and special characters."
      );
      return;
    }

    try {
      const response = await axiosInstance.post("/reset_password", {
        userId,
        newPassword,
      });
      alert(response.data.message || response.data.error);
    } catch (error) {
      console.error("Error resetting password:", error);
    }
  };

  const handleUpdateEmail = async (userId) => {
    const newEmail = prompt("Enter new email:");
    if (!newEmail) {
      alert("Email update cancelled.");
      return;
    }

    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!emailRegex.test(newEmail)) {
      alert("Please enter a valid email address.");
      return;
    }

    try {
      const response = await axiosInstance.post("/update_email", {
        userId,
        newEmail,
      });
      alert(response.data.message || response.data.error);
      if (response.status === 200) {
        fetchUsers(); // Refresh the user list
      }
    } catch (error) {
      console.error("Error updating email:", error);
    }
  };

  const handleUpdatePhone = async (userId) => {
    const newPhone = prompt("Enter new phone number:");
    if (!newPhone) {
      alert("Phone update cancelled.");
      return;
    }

    // const phoneRegex = /^\d{10}$/; // Assuming a 10-digit phone number
    // if (!phoneRegex.test(newPhone)){
    //   alert("Please enter a valid 10-digit phone number.")
    //   return
    // }

    try {
      const response = await axiosInstance.post("/update_phone", {
        userId,
        newPhone,
      });
      alert(response.data.message || response.data.error);
      if (response.status === 200) {
        fetchUsers(); // Refresh the user list
      }
    } catch (error) {
      console.error("Error updating phone:", error);
    }
  };

  const handleUpdateRole = async (userId) => {
    const newRole = prompt("Enter new role (user/admin):");
    if (!newRole || (newRole !== "user" && newRole !== "admin")) {
      alert("Invalid role. Update cancelled.");
      return;
    }

    try {
      const response = await axiosInstance.post("/update_role", {
        userId,
        newRole,
      });
      alert(response.data.message || response.data.error);
      if (response.status === 200) {
        fetchUsers(); // Refresh the user list
      }
    } catch (error) {
      console.error("Error updating role:", error);
    }
  };

  const handleDeleteUser = async (userId) => {
    if (!window.confirm("Are you sure you want to delete this user?")) {
      return;
    }

    try {
      const response = await axiosInstance.delete(
        `/auth/admin/delete-user?target_username=${userId}`
      );
      if (response.status === 200) {
        fetchUsers(); // Refresh the user list
      }
    } catch (error) {
      alert("Error deleting user: " + error.response.data.detail);
      console.error("Error deleting user:", error);
    }

    return;
  };
  const handleRegister = async () => {
    // Reset error messages
    setPasswordError("");
    setEmailError("");
    setPhoneError("");
    setUsernameError("");

    // Password validation
    const passwordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const phoneRegex = /^\d{10}$/; // Assuming a 10-digit phone number

    if (!passwordRegex.test(password) || !emailRegex.test(email)) {
      if (!passwordRegex.test(password)) {
        setPasswordError(
          "Password must be at least 8 characters long, contain letters, numbers, and special characters."
        );
      }

      if (!emailRegex.test(email)) {
        setEmailError("Please enter a valid email address.");
      }
    }

    if (!phoneRegex.test(phone)) {
      setPhoneError("Please enter a valid 10-digit phone number.");
    }
    if (!engagementName) {
      alert("Engagement name not loaded. Please try again later.");
      return;
    }

    try {
      const response = await axiosInstance.post("/auth/register", {
        username,
        password,
        email,
        phone_number: "1122334455",
        role,
        engagement_name: engagementName,
      });

      if (response.status === 200) {
        alert("Registration successful!");
        setEmail("");
        setPassword("");
        setPhone("1122334455");
        setUsername("");
        setRole("user");
        fetchUsers();
      }
    } catch (error) {
      console.error(error);
      alert("Error registering user: " + error.response.data.detail);
    }
  };

  return (
    <div>
      <ul className="nav nav-pills mb-3" id="admin-tab" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className="nav-link active"
            id="admin-register-tab"
            data-bs-toggle="pill"
            data-bs-target="#admin-register"
            type="button"
            role="tab"
            aria-controls="admin-register"
            aria-selected="true"
          >
            <b>User Registration</b>
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id="admin-list-tab"
            data-bs-toggle="pill"
            data-bs-target="#admin-list"
            type="button"
            role="tab"
            aria-controls="admin-list"
            aria-selected="false"
          >
            <b>User List</b>
          </button>
        </li>
      </ul>
      <div className="tab-content" id="admin-tabContent">
        <div
          className="tab-pane fade show active"
          id="admin-register"
          role="tabpanel"
          aria-labelledby="admin-register-tab"
          tabIndex="0"
        >
          <div />
          <div>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                margin: "10px 0",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "16px",
              }}
            />
            {usernameError && (
              <p style={{ color: "red", textAlign: "center" }}>
                {usernameError}
              </p>
            )}
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                margin: "10px 0",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "16px",
              }}
            />
            {passwordError && (
              <p style={{ color: "red", textAlign: "center" }}>
                {passwordError}
              </p>
            )}
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                margin: "10px 0",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "16px",
              }}
            />
            {emailError && (
              <p style={{ color: "red", textAlign: "center" }}>{emailError}</p>
            )}
            {/* <input
              type="tel"
              placeholder="Phone Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                margin: "10px 0",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "16px",
              }}
            />
            {phoneError && (
              <p style={{ color: "red", textAlign: "center" }}>{phoneError}</p>
            )} */}

            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                margin: "10px 0",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "16px",
                backgroundColor: "#fff",
              }}
            >
              <option value="user">User</option>
              <option value="admin">Admin</option>
            </select>
            <button
              onClick={handleRegister}
              style={{
                width: "100%",
                padding: "10px",
                margin: "10px 0",
                borderRadius: "5px",
                border: "none",
                fontSize: "16px",
                cursor: "pointer",
                backgroundColor: "#12abdb",
                color: "#fff",
              }}
            >
              Register
            </button>
            {/* {message && <p style={{ color: 'red', textAlign: 'center' }}>{message}</p>} */}
          </div>
        </div>
      </div>
      <div
        className="tab-pane fade"
        id="admin-list"
        role="tabpanel"
        aria-labelledby="admin-list-tab"
        tabIndex="1"
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "20px",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f2f2f2" }}>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Username
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Email
              </th>
              {/* <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Phone
              </th> */}
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Role
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Last Login
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {users &&
              users.map((user) => (
                <tr key={user.username} style={{ textAlign: "center" }}>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    {user.username}
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    {user.email}
                  </td>
                  {/* <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    {user.phone_number}
                  </td> */}
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    {user.role}
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    {user.last_login}
                  </td>
                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                    <button
                      onClick={() => setSelectedUser(user)}
                      style={{
                        marginRight: "5px",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        border: "none",
                        backgroundColor: "#12abdb",
                        color: "#fff",
                        cursor: "pointer",
                      }}
                    >
                      Update User
                    </button>
                    {selectedUser && (
                      <div
                        style={{
                          position: "fixed",
                          width: "100%",
                          height: "100%",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "transparent",
                          zIndex: 50,
                        }}
                        onClick={() => setSelectedUser(null)}
                      >
                        <UpdateUser
                          user={selectedUser}
                          setSelectedUser={setSelectedUser}
                          fetchUsers={fetchUsers}
                        />
                      </div>
                    )}
                    <button
                      onClick={() => handleDeleteUser(user.username)}
                      style={{
                        padding: "5px 10px",
                        borderRadius: "5px",
                        border: "none",
                        backgroundColor: "#ff4d4d",
                        color: "#fff",
                        cursor: "pointer",
                      }}
                    >
                      Delete User
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserAdministration;
